import type { TimeProviderPort } from './TimeProviderPort';

export class TimeProvider implements TimeProviderPort {
    now(): Date {
        return new Date();
    }
}
